export type JSONRegisterUser = {
  context?: {
    cycle?: string;
    feature_test_variant_name?: string;
    fixed_fee_waived_until?: string;
    lang?: string;
    locale?: string;
    next?: string;
    plan?: string;
    pricing_test_variant?: string;
    tier?: string;
  };
  marketing?: {
    attribution_snippet?: string;
    campaign?: string;
    campaign_content?: string;
    campaign_term?: string;
    http_referrer?: string;
    initial_landing_page?: string;
    medium?: string;
    ps_partner_key?: string;
    ps_xid?: string;
    raw_http_referrer?: string;
    raw_query_string?: string;
    reg_method?: string;
    registration_landing_page?: string;
    sh_ad1?: string;
    sh_ad2?: string;
    sh_ad3?: string;
    sh_ad4?: string;
    sh_device?: string;
    sh_matchtype?: string;
    source?: string;
    usps_referral_key?: string;
  };
  user: {
    company?: string;
    email: string;
    first_name: string;
    g_recaptcha_response?: string;
    last_name: string;
    password: string;
    phone?: string;
    terms?: {
      shippo?: string;
      ups_technology?: string;
    };
  };
  user_tracking?: {
    tracker_sessionid?: string;
  };
};

type RegisterUser = {
  context?: {
    cycle?: string;
    featureTestVariantName?: string;
    fixedFeeWaivedUntil?: string;
    lang?: string;
    locale?: string;
    next?: string;
    plan?: string;
    pricingTestVariant?: string;
    tier?: string;
  };
  marketing?: MarketingPayload;
  user: User;
  userTracking?: TrackingPayload;
};

type User = {
  companyName?: string;
  email: string;
  firstName: string;
  gRecaptchaResponse?: string;
  lastName: string;
  password: string;
  phone?: string;
  terms?: {
    shippo?: string;
    upsTechnology?: string;
  };
};

type MarketingPayload = {
  attributionSnippet?: string;
  campaign?: string;
  campaignContent?: string;
  campaignTerm?: string;
  httpReferrer?: string;
  initialLandingPage?: string;
  medium?: string;
  psPartnerKey?: string;
  psXid?: string;
  rawHttpReferrer?: string;
  rawQueryString?: string;
  regMethod?: string;
  registrationLandingPage?: string;
  shAd1?: string;
  shAd2?: string;
  shAd3?: string;
  shAd4?: string;
  shDevice?: string;
  shMatchtype?: string;
  source?: string;
  uspsReferralKey?: string;
};

type TrackingPayload = {
  tracker_sessionid?: string;
};

type RegisterResponse = {
  data: {
    jwt: string;
    registration_test: {
      name: string;
      variant: string;
    };
    session_token: string;
  };
};

const toJSON = (registerUser: RegisterUser): JSONRegisterUser => {
  let marketing = {};
  if (registerUser.marketing) {
    marketing = {
      attribution_snippet: registerUser.marketing.attributionSnippet,
      campaign: registerUser.marketing.campaign,
      campaign_content: registerUser.marketing.campaignContent,
      campaign_term: registerUser.marketing.campaignTerm,
      http_referrer: registerUser.marketing.httpReferrer,
      initial_landing_page: registerUser.marketing.initialLandingPage,
      medium: registerUser.marketing.medium,
      ps_partner_key: registerUser.marketing.psPartnerKey,
      ps_xid: registerUser.marketing.psXid,
      raw_http_referrer: registerUser.marketing.rawHttpReferrer,
      raw_query_string: registerUser.marketing.rawQueryString,
      reg_method: registerUser.marketing.regMethod,
      registration_landing_page: registerUser.marketing.registrationLandingPage,
      sh_ad1: registerUser.marketing.shAd1,
      sh_ad2: registerUser.marketing.shAd2,
      sh_ad3: registerUser.marketing.shAd3,
      sh_ad4: registerUser.marketing.shAd4,
      sh_device: registerUser.marketing.shDevice,
      sh_matchtype: registerUser.marketing.shMatchtype,
      source: registerUser.marketing.source,
      usps_referral_key: registerUser.marketing.uspsReferralKey,
    };
  }

  let userTracking = {};
  if (registerUser.userTracking) {
    userTracking = {
      tracker_sessionid: registerUser.userTracking.tracker_sessionid,
    };
  }

  let context = {};
  if (registerUser.context) {
    context = {
      cycle: registerUser.context.cycle,
      feature_test_variant_name: registerUser.context.featureTestVariantName,
      fixed_fee_waived_until: registerUser.context.fixedFeeWaivedUntil,
      lang: registerUser.context.lang,
      locale: registerUser.context.locale,
      next: registerUser.context.next,
      plan: registerUser.context.plan,
      pricing_test_variant: registerUser.context.pricingTestVariant,
      tier: registerUser.context.tier,
    };
  }

  return {
    context: { ...context },
    marketing: { ...marketing },
    user: {
      company: registerUser.user.companyName,
      email: registerUser.user.email,
      first_name: registerUser.user.firstName,
      g_recaptcha_response: registerUser.user.gRecaptchaResponse,
      last_name: registerUser.user.lastName,
      password: registerUser.user.password,
      phone: registerUser.user.phone,
      terms: {
        shippo: registerUser.user.terms?.shippo,
        ups_technology: registerUser.user.terms?.upsTechnology,
      },
    },
    user_tracking: { ...userTracking },
  };
};

export default RegisterUser;

export { MarketingPayload, RegisterResponse, RegisterUser, User, toJSON };
